import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useHomeContext } from "../../../context/Home_context";
import { renderTitleWithGradient } from "../../../utils/helper";
import "./HomeBrands.css";

const HomeBrands = () => {
  const { current_expo_data } = useHomeContext();
  const swiperRef = useRef(null);

  const brands = current_expo_data?.brandimage || [];

  if (brands.length === 0) return null;

  let displayBrands = [...brands];
  while (displayBrands.length < 8) {
    displayBrands = [...displayBrands, ...brands];
  }

  return (
    <section className="hb-section" id="bharat-buildcon-brands">
      <div className="hb-container">
        {/* Section Header */}
        <div className="hb-header">
          {current_expo_data?.brand_image_heading && (
            <h2 className="hb-main-title">
              {renderTitleWithGradient(
                current_expo_data.brand_image_heading,
                "hb-title-highlight"
              )}
            </h2>
          )}
          {current_expo_data?.brand_image_sub_heading && (
            <p className="hb-sub-title">
              {current_expo_data.brand_image_sub_heading}
            </p>
          )}
        </div>

        {/* Swiper Slider */}
        <div className="hb-outer-swiper-wrapper">
          <button
            type="button"
            className="hb-outer-nav-btn hb-outer-prev"
            onClick={() => swiperRef.current?.slidePrev()}
            aria-label="Previous Brand"
          >
            <FaChevronLeft />
          </button>

          <Swiper
            modules={[Autoplay, Navigation]}
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
            loop={true}
            speed={600}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            slidesPerView={1}
            spaceBetween={16}
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 16,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 22,
              },
              1600: {
                slidesPerView: 4,
                spaceBetween: 24,
              },
            }}
            className="hb-swiper"
          >
            {displayBrands.map((brand, index) => {
              const imageSrc = brand.image_full_path || brand.image;
              const link = brand.website
                ? brand.website.startsWith("http://") || brand.website.startsWith("https://")
                  ? brand.website
                  : `https://${brand.website}`
                : null;

              return (
                <SwiperSlide
                  key={`${brand.id || "brand"}-${index}`}
                  className="hb-slide"
                >
                  {link ? (
                    <a
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hb-brand-card"
                    >
                      <img
                        src={imageSrc}
                        alt="Brand Logo"
                        className="hb-brand-img"
                        loading="lazy"
                      />
                    </a>
                  ) : (
                    <div className="hb-brand-card">
                      <img
                        src={imageSrc}
                        alt="Brand Logo"
                        className="hb-brand-img"
                        loading="lazy"
                      />
                    </div>
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>

          <button
            type="button"
            className="hb-outer-nav-btn hb-outer-next"
            onClick={() => swiperRef.current?.slideNext()}
            aria-label="Next Brand"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeBrands;
